// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__-ASBY","searchBar":"SearchBar_searchBar__95JNv","input":"SearchBar_input__ib4JO","icon":"SearchBar_icon__wCujC","clear":"SearchBar_clear__hRTIr"};